import { makeAutoObservable } from 'mobx';

class GeneralStore {
  isLoading = false;
  error?: { message: string; error?: any };
  infoMsg?: string;

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };

  setInfoMsg = (message: string) => {
    this.infoMsg = message;
  };

  unsetInfoMsg = () => {
    this.infoMsg = undefined;
  };

  setError = (message: string, error?: any) => {
    this.error = { message, error: error };
  };

  unsetError = () => {
    this.error = undefined;
  };
}

const generalStore = new GeneralStore();

export { generalStore };
